<template>
  <div>
    <div class="section-header">
      Pulse Surveys
    </div>
    <div class="card card--white">
      <div class="card--container">
        <div v-infinite-scroll="findSurveys" infinite-scroll-disabled="busy" infinite-scroll-distance="15" v-if="pulseSurveys.length > 0">
          <div v-for="pulseSurvey in pulseSurveys" :key="pulseSurvey.id">
            <router-link class="card-text-header" :to="{'name': 'pulseSurveyDetail', params:{'id': pulseSurvey.id}}">
              {{pulseSurvey.name}}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Paginator from "@/services/api/paginator";
const PULSE_SURVEY_STORE = "CoachPulseSurveys";

export default {
  data() {
    return {
      pulseSurveys: [],
      busy: false
    };
  },
  created() {
    this.start();
  },
  methods: {
    start() {
      this.pulseSurveys = [];
      this.pulseSurveyPaginator = new Paginator(
        PULSE_SURVEY_STORE,
        { deleted: false },
        { force: true }
      );
      this.findSurveys();
    },
    findSurveys() {
      if (this.pulseSurveyPaginator.finished) {
        return;
      }
      this.busy = true;
      this.pulseSurveyPaginator.next().then(results => {
        this.pulseSurveys = [...this.pulseSurveys, ...results];
        this.busy = false;
      });
    }
  }
};
</script>

<style>
</style>
